import { Select } from 'antd'
import React, { useEffect } from 'react'
import Loader from '../pages/pages/loader'
import { toast } from 'react-toastify'
import { useGetAppStatusListQuery } from '../redux/apis/linkManagement/app/status/lmAppsStatusApiSlice'

const AppStatusDropdown = ({
  onChange,
  onBlur,
  value,
  className = '',
  mode=''
}) => {
  const { data, isLoading, error } = useGetAppStatusListQuery({
    page: '*',
    fields: ['id','status'].join(','),
  })

useEffect(()=>{
        if ( !error && !isLoading) {
            return
        }
        toast.error(error)
    },[error, isLoading])

  return (
    <div className=' mb-3'>
      <Loader isLoading={isLoading} />
      <label className="form-label">App Status</label>
      <br />
      <Select
        name='status'
        className={className}
        showSearch
        style={{
          width: '100%'
        }}
        optionFilterProp='label'
        filterSort={(optionA, optionB) =>
          (optionA?.label ?? '')
            .toLowerCase()
            .localeCompare((optionB?.label ?? '').toLowerCase())
        }
        defaultValue={value}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        loading={isLoading}
        options={data?.data?.results?.map(x => {
          return { label: x.status, value: x.id }
        })}
        mode={mode}
      />
    </div>
  )
}

export default AppStatusDropdown
